import { render, staticRenderFns } from "./GripWrite.vue?vue&type=template&id=0a8f7285&"
import script from "./GripWrite.vue?vue&type=script&lang=js&"
export * from "./GripWrite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports